import { generateShortId } from '@utils';

const DEFAULT_DROPDOWN = {
  text: '-',
  value: null,
};

const STATUSES = [
  {
    text: '-',
    value: '',
  },
  {
    text: 'Published',
    value: 'published',
  },
  {
    text: 'Unpublished',
    value: 'unPublished',
  },
];

const CATALOG_EBIKES_PAGE_SIZE = 50;

const INITIAL_EBIKE_VALUES = {
  skuId: '',
  type: '',
  name: '',
  properties: {
    brand: '',
    brandSlug: '',
    model: '',
    modelSlug: '',
    edition: '',
    year: '',
    engine: {
      displacement: '',
      powerHp: 250,
      fuelType: '',
      type: '',
      fuelEconomy: '',
      emissions: '',
      fuelCapacity: '',
      topSpeed: '',
      torque: '',
      euroClass: '',
      autonomy: '',
      speed: '',
      batterySize: '',
      tireSize: '',
      batteryChargeTime: '',
      acceleration: '',
      numberOfGears: '',
    },
    body: {
      type: '',
      size: '',
      seatsNumber: '',
      doorsNumber: '',
      airbagsNumber: '',
      height: '',
      weight: '',
      interiorType: '',
      trunkCapacity: '',
      length: '',
      width: '',
    },
    transmission: '',
    category: '',
    productLine: '',
    tireSize: '',
    equipment: {
      comfort: {
        'el-GR': '',
        'en-US': '',
      },
      exterior: {
        'el-GR': '',
        'en-US': '',
      },
      interior: {
        'el-GR': '',
        'en-US': '',
      },
      multimedia: {
        'el-GR': '',
        'en-US': '',
      },
      safety: {
        'el-GR': '',
        'en-US': '',
      },
    },
  },
  images: [],
  docs: [],
  pricing: [
    {
      id: generateShortId(),
      type: 0, // open
      monthsDuration: null,
      signUpFee: null,
      price: '0.00',
      initialPrice: '0.00',
    },
    {
      id: generateShortId(),
      type: 1, // fixed
      monthsDuration: 3,
      signUpFee: null,
      price: '0.00',
      initialPrice: '0.00',
    },
    {
      id: generateShortId(),
      type: 1, // fixed
      monthsDuration: 6,
      signUpFee: null,
      price: '0.00',
      initialPrice: '0.00',
    },
  ],
  instastart: '',
  signUpFee: '',
  pricingWithVat: {
    vatApplied: '',
    price: '',
    instastart: '',
    signUpFee: '',
    initialPrice: '',
  },
  monthlyKilometers: '',
  tags: [],
  published: false,
  colors: [],
  vendors: [],
  availability: -1,
  pricePerKm: '',
  chargePerExtraKm: '',
  retailPrice: '',
  instacarPrice: '',
  videoUrl: '',
  extras: [],
  additionalInfo: {
    'el-GR': '',
    'en-US': '',
  },
  selectedImageId: '',
  comments: '',
  cities: [],
  createdAt: '',
  createdBy: '',
  updatedAt: '',
  updatedBy: '',
};

const EBIKES_BY_SKU_PAGE_SIZE = 50;
const EBIKES_SIZES = ['small', 'medium', 'large'];
const EBIKES_TYPES = [
  'scooter',
  'folding',
  'trekking',
  'citytrekking',
  'fatbike',
  'mountainbike',
  'wagon',
  'escooter',
  'road',
  'epatini',
];

export {
  DEFAULT_DROPDOWN,
  STATUSES,
  CATALOG_EBIKES_PAGE_SIZE,
  INITIAL_EBIKE_VALUES,
  EBIKES_SIZES,
  EBIKES_BY_SKU_PAGE_SIZE,
  EBIKES_TYPES,
};
